.container {
    padding: 32px 16px;
}

.container a {
    text-decoration: underline;
}
